import React from 'react';
import { translate } from 'react-i18next';
import { Segment, Container, Icon, Checkbox, Grid, Button } from 'semantic-ui-react';

import EditLevelContainer from './EditLevelContainer.js';
import EditFrequencyContainer from './EditFrequencyContainer.js';
import EditTimeContainer from './EditTimeContainer.js';
import {getNotificationFrequency, formatTime} from './tools.js';
import Utils from 'utils/Utils.js';

import {colors, fontSizes, fonts, spacings, shadow, layout} from 'style';

var style = {
    imageBanner: {
        position: 'relative',
        height:'300px', 
        width:'100%',
        backgroundSize:'cover',
        backgroundPositionY: 'center',
        backgroundPositionX: 'center',
        boxShadow: shadow,
        maxWidth: '522px',
        borderRadius: spacings.small,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    container: {
        maxWidth: layout.screenWidth,
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: spacings.base,
        backgroundColor: 'white',
    },
    segment: {
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    contentDiv: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        float:'right',
    },
    toggle: {
        position: 'relative',
        top: '5px',
    },
    grid: {
        padding: '15px 0px 0px 0px',
    },
    row: {
        minHeight: '52px',
        lineHeight: '52px',
        paddingTop: '0',
        paddingBottom: '0',
        borderBottom: '1px solid ' + colors.themeDarkGrey1_2,
    },
    description: {
        borderBottom: 'none',
        paddingTop: spacings.base,
        paddingBottom: spacings.base,
    },
    button: {
        margin: '0 0 0 0',
        fontWeight: 'normal',
        borderRadius: '100px',
        backgroundColor: colors.themeBlue,
        color: '#fff',
        width: '180px',
        boxShadow: shadow,
    },
    text: {
        ...fonts.body,
        lineHeight: '1.5',
        opacity: '0.75',
    }
};

const Category = ({t,
                   busy,
                   category, 
                   alwaysOn,
                   onToggleSubscription, 
                   onToggleNotification, 
                   updateNotification, 
                   updateLevel, 
                   getCategoryImageUrl, 
                   isEnabled, 
                   notification, 
                   onShowEditFrequency, 
                   onShowEditTime, 
                   onShowEditLevel, 
                   showEditFrequency, 
                   showEditTime, 
                   showEditLevel}) => (
    <div style={style.container}>
        {Boolean(!busy && category) &&
        <div style={style.segment}>
            <div style={{...style.imageBanner, backgroundImage:Utils.url(getCategoryImageUrl(category))}} />
            <Grid style={style.grid} columns={1} centered>

                {!alwaysOn &&
                <Grid.Row key='0' style={style.row}>
                    <Grid.Column verticalAlign='bottom' textAlign='left'>
                        <div>
                            <span style={style.text}>{t('Activate Goal')}</span>
                            <div style={style.contentDiv}>
                                <Checkbox style={style.toggle} data-id={category.id} toggle checked={isEnabled} onChange={onToggleSubscription}/>
                            </div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                }

                {isEnabled && ((category.numLevels||0)>0) &&
                <Grid.Row key='1' style={style.row}>
                    <Grid.Column verticalAlign='bottom' textAlign='left'>
                        <div>
                            <span style={style.text}>{t('Level')}</span>
                            <div style={style.contentDiv}>
                                <Button style={style.button} onClick={()=>onShowEditLevel(true)}>
                                    {category.userCategory.level}
                                </Button>
                            </div>
                            {showEditLevel &&
                                <EditLevelContainer 
                                    onSubmit={(level)=>updateLevel(category.id, level)}
                                    level={category.userCategory.level}
                                    maxLevel={category.userCategory.maxLevel}
                                    numLevels={category.numLevels}
                                    onClose={()=>onShowEditLevel(false)}
                                />
                            }
                        </div>
                    </Grid.Column>
                </Grid.Row>
                }
                {isEnabled &&
                <Grid.Row key='2' style={style.row}>
                    <Grid.Column verticalAlign='bottom' textAlign='left'>
                        <div>
                            <span style={style.text}>{t('Notification')}</span>
                            <div style={style.contentDiv}>
                                <Checkbox style={style.toggle} data-id={category.id} toggle checked={Boolean(notification!=null && notification.active==true)} onChange={onToggleNotification}/>
                            </div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                }

                {isEnabled && notification!=null && notification.active==true && [
                <Grid.Row key='3' style={style.row}>
                    <Grid.Column verticalAlign='bottom' textAlign='left'>
                        <div>
                            <span style={style.text}>{t('Time')}</span>
                            <div style={style.contentDiv}>
                                <Button style={style.button} onClick={()=>onShowEditTime(true)}>
                                    {formatTime(notification.time)}
                                </Button>
                            </div>
                            {showEditTime &&
                                <EditTimeContainer 
                                    initialTime={notification.time} 
                                    onSubmit={(time)=>updateNotification(category.id, {...notification, time:time, defaultTime:time})}
                                    onClose={()=>onShowEditTime(false)}
                                />
                            }
                        </div>
                    </Grid.Column>
                </Grid.Row>
                ,
                <Grid.Row key='4' style={style.row}>
                    <Grid.Column verticalAlign='bottom' textAlign='left'>
                        <div>
                            <span style={style.text}>{t('Frequency')}</span>
                            <div style={style.contentDiv}>
                                <Button style={style.button} onClick={()=>onShowEditFrequency(true)}>
                                    {getNotificationFrequency(t, notification)}
                                </Button>
                            </div>
                            {showEditFrequency &&
                                <EditFrequencyContainer 
                                    initialPattern={notification.pattern} 
                                    onSubmit={(pattern)=>updateNotification(category.id, {...notification, pattern})}
                                    onClose={()=>onShowEditFrequency(false)}
                                />
                            }
                        </div>
                    </Grid.Column>
                </Grid.Row>
                ]}

                {category.description &&
                <Grid.Row key='5' style={{...style.row, ...style.description}}>
                    <Grid.Column verticalAlign='bottom' textAlign='left'>
                        <div style={style.text}>{category.description}</div>
                    </Grid.Column>
                </Grid.Row>
                }

            </Grid>
        </div>
        }
        {false &&
            <pre>{JSON.stringify(category,null,2)}</pre>
        }
    </div>
);


export default translate('categories')(Category);



// WEBPACK FOOTER //
// ./src/modules/categories/Category.js